import axios from "axios";
import request from "../../request";
import moment from "moment";

let isFetchingCart = false; // Flag to prevent multiple API calls

export const GETCART = (dispatch, cartCount) => {
    async function getcart() {
        if (isFetchingCart) return; // Prevent multiple calls
        isFetchingCart = true; // Set the flag

        const rolesdata = JSON.parse(localStorage.getItem("companyrolesdata"));
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        let aid = rolesdata?.some(
            (rd) =>
                rd?.name === "Administrator" &&
                rd?.id ===
                userdata?.extension_attributes?.aw_ca_company_user?.company_role_id
        );
        let sid = rolesdata?.some(
            (rd) =>
                rd?.name === "Supervisor" &&
                rd?.id ===
                userdata?.extension_attributes?.aw_ca_company_user?.company_role_id
        );
        let pid = rolesdata?.some(
            (rd) =>
                rd?.name === "Purchaser" &&
                rd?.id ===
                userdata?.extension_attributes?.aw_ca_company_user?.company_role_id
        );
        let rolesid = aid ? 0 : sid ? 1 : pid ? 2 : null;
        let local_user_id = localStorage.getItem("userid");
        let local_company_id = localStorage.getItem("companyid");

        if (rolesid === null) {
            isFetchingCart = false; // Reset the flag
            return;
        }

        try {

            // Get Cart Data
            const cartdata = await axios({
                method: "get",
                url: `${request.getcart}/${local_company_id}/${local_user_id}/${rolesid}`,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            if (!cartCount) {
                dispatch({
                    type: "UPDATE_CART_COUNT",
                    data: cartdata?.data[0]?.items.length,
                });
            }
            dispatch({
                type: "UPDATE_CART",
                data: cartdata?.data[0]?.items,
            });
            dispatch({
                type: "SELECTED_DATA",
                data: cartdata.data[1]?.product_selected,
            });
            dispatch({
                type: "VAT_DATA",
                data: cartdata.data[1]?.product_selected,
            });
            dispatch({
                type: "SUMMARY_DATA",
                data: cartdata.data[3]?.summary,
            });
            dispatch({
                type: "PRODUCT_COUNT",
                data: cartdata.data[4]?.product_count,
            });
            dispatch({
                type: "CURRENT_ORDER",
                data: cartdata.data[5]?.current_order_id,
            });
            dispatch({
                type: "SLAB_DATA_SHOW",
                data: cartdata.data[8]?.slabshow || [],
            });
            dispatch({
                type: "SLAB_DATA",
                data: cartdata.data[9]?.slabdata || [],
            });
            const minOrderAmount = cartdata.data[6]?.minorderamount;
            const customerCode = cartdata.data[7]?.custCode;

            dispatch({
                type: "MIN_ORDER_AMOUNT",
                data: minOrderAmount || null,
            });
            dispatch({
                type: "CUSTOMER_CODE",
                data: customerCode || null,
            });
        } catch (e) {
            console.log(e);
            // toast.error(e.response?.data?.message);
        } finally {
            isFetchingCart = false; // Reset the flag after the call
        }
    };
    getcart();
}

export const GETCARTID = (USERID, TOKEN) => {
    if (!TOKEN) {
        console.warn("User not logged in. Skipping GETCARTID API call.");
        return;
    }

    async function getcartid() {
        try {
            const data = await axios({
                method: 'post',
                url: request?.cardid,
                data: {
                    customerId: USERID
                },
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });

            localStorage.setItem('cartid', data?.data);
        } catch (e) {
            console.error("GETCARTID error:", e);
        }
    }

    getcartid();
};


export const ADDTOCART = async (dispatch, value, cart, toast, setShowNoAddressModal) => {
    if (value?.is_in_stock === "0") {
        return;
    }

    const USERID = localStorage.getItem("userid");
    const TOKEN = localStorage.getItem("token");
    let COMPANYID = localStorage.getItem("companyid");
    let CARTID = localStorage.getItem("cartid");
    let ADDRESSDATA = [];

    async function getDate() {
        try {
            const response = await axios.get(`${request.getbranch}/${USERID}`, {
                headers: {
                    "Authorization": `Bearer ${TOKEN}`,
                },
            });
            // For social login user her check delivery address there or not, if not user need to add deliveryaddress
            if (response?.data?.length === 0) {
                setShowNoAddressModal(true);
                return;
            }
            ADDRESSDATA = response.data;
        } catch (error) {
            console.log(error);
        }
    }

    await getDate(); // Wait for the asynchronous request to complete

    let DEFAULTADDRESS;
    const defaultAddress = ADDRESSDATA.find((data) => data.chk_default === "Y");

    if (defaultAddress) {
        DEFAULTADDRESS = defaultAddress;
    }

    const FINDSKU = cart.find((c) => c.sku === value.sku);

    let date;
    try {
        const datechk = await axios({
            method: "get",
            url: `${request.erprequest}/products/${value?.sku}/delivery-date`,
            headers: {
                token: `Bearer ${localStorage.getItem("erpToken")}`,
            },
        });
        date = datechk.data.data[0].DELIVER_DATE.slice(parseInt(DEFAULTADDRESS?.leadtime_days));
    } catch (e) {
        console.log(e);
    }

    if (date) {
        try {
            const cartdata = await axios({
                method: "post",
                url: request.cartadd,
                data: {
                    cartItem: {
                        sku: value?.sku,
                        quote_id: CARTID,
                        qty: value?.moq ? parseInt(value.moq) : 1,
                        price: value?.options[0]?.price,
                        extension_attributes: {
                            unit: value?.options[0]?.order_type,
                        },
                    },
                    splitorder: {
                        company_id: COMPANYID,
                        customer_id: USERID,
                        branch_id: DEFAULTADDRESS?.address_id,
                        product_id: value?.entity_id,
                        item_id: FINDSKU?.item_id ? FINDSKU?.item_id : 0,
                        name: value.name,
                        sku: value.sku,
                        delivery_date: moment(date[0]?.DD).format("YYYY-MM-DD"),
                    },
                },
                headers: {
                    "Authorization": `Bearer ${TOKEN}`,
                },
            });

            if (cartdata.data[0].errors == false) {
                toast.info("The Requested qty is not available");
            }

            if (cartdata.data[0].success) {
                // createlog();
                toast.success(`${value?.name} added to the cart Successfully`);
            }

            dispatch({
                type: "CART_STATUS",
            });
        } catch (e) {
            console.log(e);
        }
    }
}


// export const BULKADDTOCART = async (dispatch, items, cart, toast, setShowNoAddressModal) => {
//     // Check if there are any items to process
//     if (!items || items.length === 0) {
//         return;
//     }

//     const USERID = localStorage.getItem("userid");
//     const TOKEN = localStorage.getItem("token");
//     let COMPANYID = localStorage.getItem("companyid");
//     let CARTID = localStorage.getItem("cartid");

//     // Prepare a temporary list to hold items for the bulk API call
//     const bulkCartItems = [];

//     // Loop through each item to construct the payload
//     for (const item of items) {

//         const FINDSKU = cart.find((c) => c.sku === item.sku);

//         bulkCartItems.push({
//             cartItem: {
//                 sku: item?.sku,
//                 quote_id: CARTID,
//                 qty: item?.qty,
//                 // price: item?.options[0]?.price || 100,
//                 price: item?.price,  // new API   // stock
//                 extension_attributes: {
//                     unit: item?.ORDER_UNIT,
//                 },
//             },
//             splitorder: {
//                 company_id: COMPANYID,
//                 customer_id: USERID,
//                 branch_id: item?.branch_id,
//                 product_id: item?.entity_id || "",
//                 item_id: FINDSKU?.item_id ? FINDSKU?.item_id : 0,
//                 // item_id: 0,
//                 name: item.name,
//                 sku: item.sku,
//                 delivery_date: moment(item.delivery_date).format("YYYY-MM-DD"),
//             },
//         });
//     }

//     // Make a single bulk API call if there are items to add
//     if (bulkCartItems.length > 0) {
//         try {
//             const response = await axios({
//                 method: "post",
//                 url: request.bulkcartadd, // Using the new bulk endpoint
//                 data: {
//                     bulkCart: bulkCartItems,
//                 },
//                 headers: {
//                     "Authorization": `Bearer ${TOKEN}`,
//                 },
//             });
//             console.log("******* response *********", response)
//             // Handle the response for the bulk operation
//             const { data } = response;

//             const successfulItems = data[0]?.cartAdded?.length;
//             const failedItems = data[0].error.length;
//             if (successfulItems > 0) {
//                 toast.success(`Successfully imported ${successfulItems} items!`);
//             }

//             if (failedItems > 0) {
//                 console.error("Failed to import some items:", failedItems);
//                 toast.error(`Failed to import ${failedItems} item(s).`);
//             }

//             dispatch({
//                 type: "CART_STATUS",
//             });
//         } catch (e) {
//             console.log("Bulk Add to cart API catch Error : ", e);
//             toast.error("An unexpected error occurred.");
//         }
//     } else {
//         toast.info("No valid items to add to the cart.");
//     }
// }

// This function receives the pre-formatted bulkCart array directly
export const BULKADDTOCART = async (dispatch, bulkCartItems, cart, toast, setShowNoAddressModal) => {
    if (!bulkCartItems || bulkCartItems.length === 0) {
        toast.info("No valid items to add to the cart.");
        return;
    }

    const USERID = localStorage.getItem("userid");
    const TOKEN = localStorage.getItem("token");
    const COMPANYID = localStorage.getItem("companyid");
    const CARTID = localStorage.getItem("cartid");

    // Fill in the required dynamic data for each item
    const finalBulkCart = bulkCartItems.map(item => {
        // Add company and customer IDs to the splitorder parts
        item.splitorder = item.splitorder.map(splitPart => ({
            ...splitPart,
            company_id: COMPANYID,
            customer_id: USERID,
        }));

        // Add the quote_id to the cartItem
        item.cartItem.quote_id = CARTID;

        return item;
    });
    try {
        const response = await axios({
            method: "post",
            url: request.bulkcartadd,
            data: {
                bulkCart: finalBulkCart,
            },
            headers: {
                "Authorization": `Bearer ${TOKEN}`,
            },
        });
        const { data } = response;
        const successfulItems = data[0]?.cartAdded?.length || 0;
        const failedItems = data[0]?.error?.length || 0;

        if (successfulItems > 0) {
            toast.success(`Successfully imported ${successfulItems} items!`);
        }

        if (failedItems > 0) {
            console.error("Failed to import some items:", data.error);
            toast.error(`Failed to import ${failedItems} item(s). See console for details.`);
        }

        dispatch({
            type: "CART_STATUS",
        });
    } catch (e) {
        console.log("Bulk Add to cart API catch Error : ", e);
        toast.error("An unexpected error occurred.");
    }
};